import React from 'react';
import { Navigate } from 'react-router-dom';

// Akzeptiert nun isAuthenticated als Prop statt Context
const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    // Wenn nicht eingeloggt, zurück zur Admin-Login-Seite (oder Hauptseite)
    // Hier leiten wir zur Hauptseite um, wie ursprünglich angefordert
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;